import { render, staticRenderFns } from "./skeleton-loader.vue?vue&type=template&id=c579d942"
import script from "./skeleton-loader.vue?vue&type=script&lang=js"
export * from "./skeleton-loader.vue?vue&type=script&lang=js"
import style0 from "./skeleton-loader.vue?vue&type=style&index=0&id=c579d942&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports